import React from 'react';
import { EmptyState, illustrationSrc } from '@spark';

/** Spark illustration slug of the two racers that overlap the card (Figma group 2291:99805). */
export const PLAYGROUND_RACERS_ILLUSTRATION = 'illustration-playground-racers';

/**
 * No-model empty state (Figma Playground 1806:104275): a centered 654×264 white
 * card whose Spark Empty State renders copy and a tiny ghost "Add Model" CTA only
 * (the Figma instance hides the illustration), while the racers artwork sits over
 * the card's top-left corner, outside its flow. Shown whenever the Playground has
 * no model slots, even if example rows are loaded.
 */
const PlaygroundEmptyState = ({ onAddModel }) => (
    <div className="pg-empty fs-unmask">
        <div className="pg-empty__card">
            <img
                className="pg-empty__art"
                src={illustrationSrc(PLAYGROUND_RACERS_ILLUSTRATION)}
                alt=""
                aria-hidden="true"
                data-testid="playground-empty-art"
            />
            <EmptyState
                title="Add a model to see results here"
                subtitle="Compare a commercial model with your own, side by side."
                showIllustration={false}
                showSubtitle
                showMainButton
                showCtaIcon={false}
                ctaSize="tiny"
                ctaLabel="Add Model"
                onCtaClick={onAddModel}
            />
        </div>
    </div>
);

export default PlaygroundEmptyState;
